import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { Row } from 'further-ui/components/Layout';

type Props = {
  label: string;
  value: string | boolean;
};

const ReadOnlyDatapoint: FC<Props> = ({ label, value }) => (
  <Row spacing="xs" centered breakpoint="sm">
    <Typography variant="h6" color="grey.600" width="300px" noWrap>
      {label}
    </Typography>
    <Typography variant="body2" color="grey.900">
      {typeof value === 'string' ? value : value ? 'Enabled' : 'Disabled'}
    </Typography>
  </Row>
);

export default ReadOnlyDatapoint;
